// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eswitch_fpg_web--StackBarChart-module--container--UIG7NGf0Q9wh5WdJ55ua {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 350px;
}

.eswitch_fpg_web--StackBarChart-module--canvasContainer--JQtNWYRx7DZCvnxXFvyW {
  height: 200px;
  width: 100%;
  padding: 0 33px;
}

.eswitch_fpg_web--StackBarChart-module--legendWrapper--kvqjVKvvtAvTWPmir7h3 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.eswitch_fpg_web--StackBarChart-module--legendItem--plxpmNMkJ_jHYAefnrU8 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
}

.eswitch_fpg_web--StackBarChart-module--legendLabel--xb6EzJT0vLvuMpOqt7af {
  padding-left: 5px;
  font-family: var(--fmc-font--inter);
}

.eswitch_fpg_web--StackBarChart-module--colorBox--OGvjqcV3XX3suZv52_ag {
  width: 24px;
  height: 24px;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/Charts/StackBarChart/StackBarChart.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mCAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 350px;\n}\n\n.canvasContainer {\n    height: 200px;\n    width: 100%;\n    padding: 0 33px;\n}\n\n.legendWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.legendItem {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n\n.legendLabel {\n    padding-left: 5px;\n    font-family: var(--fmc-font--inter);\n}\n\n.colorBox {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `eswitch_fpg_web--StackBarChart-module--container--UIG7NGf0Q9wh5WdJ55ua`,
	"canvasContainer": `eswitch_fpg_web--StackBarChart-module--canvasContainer--JQtNWYRx7DZCvnxXFvyW`,
	"legendWrapper": `eswitch_fpg_web--StackBarChart-module--legendWrapper--kvqjVKvvtAvTWPmir7h3`,
	"legendItem": `eswitch_fpg_web--StackBarChart-module--legendItem--plxpmNMkJ_jHYAefnrU8`,
	"legendLabel": `eswitch_fpg_web--StackBarChart-module--legendLabel--xb6EzJT0vLvuMpOqt7af`,
	"colorBox": `eswitch_fpg_web--StackBarChart-module--colorBox--OGvjqcV3XX3suZv52_ag`
};
export default ___CSS_LOADER_EXPORT___;
